import { ReactNode } from 'react';
import styled from 'styled-components';

interface ColumnProps {
  children?: ReactNode;
  key?: any;
}

const Column = styled.div<ColumnProps>`
  padding: 3px 17px;
  display: flex;
  flex-direction: column;
`;

export default Column;
